import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/landing/LandingPage';
import CostCalculator from './components/landing/CostCalculator';
import TermsOfService from './components/legal/TermsOfService';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TrustAndSafety from './components/legal/TrustAndSafety';
import './index.css';

function App() {
  // Redirect /live/* to platform subdomain (for old SMS links)
  if (window.location.pathname.startsWith('/live/')) {
    window.location.href = 'https://platform.remote-assistant.io' + window.location.pathname + window.location.search;
    return null;
  }

  // Redirect auth-related paths to platform
  const authPaths = ['/dashboard', '/studio', '/playground', '/evaluate', '/optimize',
    '/api-keys', '/logs', '/usage', '/settings', '/action-items', '/docs', '/logout'];
  if (authPaths.some(p => window.location.pathname.startsWith(p))) {
    window.location.href = 'https://platform.remote-assistant.io' + window.location.pathname;
    return null;
  }

  const navigateToLogin = (signUp) => {
    window.location.href = signUp
      ? 'https://platform.remote-assistant.io?signup=true'
      : 'https://platform.remote-assistant.io';
  };

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/pricing-calculator" element={<CostCalculator onNavigateLogin={navigateToLogin} />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/toc" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/trust-and-safety" element={<TrustAndSafety />} />
          <Route path="*" element={<LandingPage onNavigateLogin={navigateToLogin} />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
